import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from '../../../orders/models';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { takeUntil } from 'rxjs/operators';
import { BaseOnDestroyComponent } from '../../injectables/BaseOnDestroy.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateShipmentDialogComponent } from '../../components/create-shipment-dialog/create-shipment-dialog.component';
import { extractIri } from '../../utilities/objects.utility';
import { ActionBoxInputTypes } from '../../models/action-box-input-types.type';
import { AuthService } from '../../../auth/services/auth.service';
import { TransitionsActions } from '../../../application-state/store/actions';
import { PotentialAction } from '../../models';

@Component({
  selector: 'app-action-box-to-return-shipment',
  styleUrls: ['./action-box-to-return-shipment.component.scss'],
  template: `
    <div class="action-box">
      <div class="action-required-label" *ngIf="canMakeTransition">
        Aktion erforderlich
      </div>
      <div class="action-required-label bg-green" *ngIf="!canMakeTransition">
        Warte auf Zuarbeit
      </div>
      <div class="content ">
        <div class="row" *ngIf="canMakeTransition">
          <div class=" col-auto my-2 align-items-center">
            <div class="row ">
              <div class=" col-auto header">
                Datenträger an Kunden verschicken
              </div>
              <div class="sub-header col-auto">
                Die Datenträger sind an den Kunden zu verschicken!
              </div>
            </div>
          </div>
          <div class="actions col mt-2 text-right">
            <button
              mat-button
              color="green"
              class="mb-3"
              [disabled]="dataMedia.length <= 0"
              (click)="handleClickAddShipment()"
            >
              <mat-icon class="m-r--8">local_shipping</mat-icon>
              <span>Versand beauftragen</span>
            </button>
            <span *ngIf="canMakeTransition && okAction">
              <br />Dann:
              <button mat-flat-button (click)="handleMakeTransition()">
                Versand beauftragt, Auftrag abschließen
              </button>
            </span>
          </div>
        </div>
        <div class="row " *ngIf="!canMakeTransition">
          <div class=" col-auto header">Versand an Kunden</div>
          <div class="sub-header col-auto">
            Warte auf Versand des Datenträgers an Kunden
          </div>
        </div>
      </div>
      <div class="additional-content p-4" *ngIf="canMakeTransition">
        <div class="row">
          <app-order-stock-item-select-list
            [readonlyArchive]="true"
            (updateSelectedDataMedia)="setSelectedDataMedia($event)"
          ></app-order-stock-item-select-list>
        </div>
      </div>
    </div>
  `
})
export class ActionBoxToReturnShipmentComponent extends BaseOnDestroyComponent
  implements OnInit {
  @Input() order$: Observable<Order>;
  @Input() inputType: ActionBoxInputTypes;

  order: Order;
  dataMedia: Array<string> = [];
  okAction: PotentialAction = null;

  constructor(
    private store$: Store<ApplicationState>,
    private authService: AuthService,
    private dialog: MatDialog,
    private fb: FormBuilder
  ) {
    super();
  }

  get canMakeTransition(): boolean {
    return (
      (this.inputType === 'order' &&
        (this.authService.isLogistic() ||
          this.authService.isAdmin() ||
          this.authService.isSupervisor() ||
          this.authService.isTechnician() ||
          this.authService.isTechnicianExternal())) ||
      false
    );
  }

  ngOnInit(): void {
    this.order$.pipe(takeUntil(this.onDestroy$)).subscribe(order => {
      this.order = order;
      this.okAction = order.potentialActions?.find(
        e =>
          e.transition.indexOf('return_shipment_to_order_closed') > -1 &&
          !e.error
      );
    });
  }

  setSelectedDataMedia(list: Array<string>): void {
    this.dataMedia = list;
  }

  handleMakeTransition(): void {
    const action = this.okAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }

  handleClickAddShipment(): void {
    this.dialog.open(CreateShipmentDialogComponent, {
      panelClass: 'width-95',
      data: {
        actionAfterCreation: 'OPEN_SHIPMENT',
        shipment: {
          order: extractIri(this.order),
          dataMedia: this.dataMedia,
          shipmentDirection:
            '/api/shipment_directions/SHIPMENT_DIRECTION_DR_DE_TO_CUSTOMER'
        }
      }
    });
  }
}
